import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@sm360/ui-library'
import clsx from 'clsx'

const Cta = ({ label, handleClick, extraClasses }) => {
    const classNames = clsx('a-button -primary', extraClasses)

    return <Button className={classNames} label={label} onClick={handleClick} />
}

Cta.propTypes = {
    label: PropTypes.string,
    handleClick: PropTypes.func,
    extraClasses: PropTypes.string,
}

Cta.defaultProps = {
    label: '',
    handleClick: () => {},
    extraClasses: '',
}

export default Cta
